import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import CtaPropTypes from '../../prop-types/cta';

import * as Styled from './Reveal.styled';

/**
 * Shows a group of CTAs on top of a backdrop
 *
 * Intended for use with Content System cards, but usage outside of the Content System is also expected
 */
const Reveal = ({ setIsOpen, ctas, size, backgroundColor }) => {
  useEffect(() => {
    const handleGlobalClick = () => setIsOpen(false);

    document.addEventListener('click', handleGlobalClick, {
      capture: true,
      once: true
    });

    return () => {
      document.removeEventListener('click', handleGlobalClick, {
        capture: true
      });
    };
  }, []);

  return (
    <Styled.Reveal>
      <Styled.Backdrop />
      <Styled.Ctas $responsiveStyleSize={size}>
        {ctas.slice(1).map(
          ({ text, url }) =>
            text &&
            text.trim() && (
              <Styled.Cta
                as="a"
                href={url}
                variant="primary"
                key={text + url}
                size={size === 'mega' ? 'large' : 'medium'}
                $backgroundColor={backgroundColor}
              >
                {text}
              </Styled.Cta>
            )
        )}
      </Styled.Ctas>
    </Styled.Reveal>
  );
};

Reveal.propTypes = {
  /**
   * Opens or closes the reveal module
   */
  setIsOpen: PropTypes.func.isRequired,
  /**
   * An array of CTAs
   */
  ctas: PropTypes.arrayOf(PropTypes.shape(CtaPropTypes)),
  /**
   * Applies styling to copy based on content system responsive rules
   */
  size: PropTypes.oneOf(['mini', 'regular', 'mega']),
  /**
   * Background color, supplied as a hex code
   */
  backgroundColor: PropTypes.string
};

Reveal.defaultProps = {
  ctas: null,
  size: 'regular',
  backgroundColor: convertColorToThemeHexCode('white')
};

export default Reveal;
